export default "__VITE_ASSET__C$VoBerM__"